import React from "react";
import FormHeader from "../../components/FormHeader";
import BaseFormPage from "../../components/BaseFormPage";
import BaseInput from "../../components/BaseInput";
import RadioGenders from "../../components/RadioGenders";
import BaseButton from "../../components/BaseButton";
import TermsAndPrivacy from "./components/TermsAndPrivacy";
import useViewController from "./viewController";
import useController from "./controller";
import BaseError from "../../components/BaseError";
import BirthDayDatePicker from "./components/BirthDayDatePicker";
import { useTranslation } from "react-i18next";
import NavigateToIfAuth from "../../hocs/NavigateToIfAuth";
import FirstTimeInGameModal from "../../modals/FirstTimeInGameModal";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../utils/routes.js";
import NavigateToLoginBtn from "../../components/NavigatoToLoginBtn/NavigateToLoginBtn";
import "./style.scss";
import GenderNotification from "../../modals/GenderNotification";
import SupportButton from "../../components/SupportButton";
import MobileAppSelectLang from "../../components/MobileAppSelectLang";

export default NavigateToIfAuth(function RegisterPage() {
  useViewController();
  const navigate = useNavigate();
  const {
    onSubmitForm,
    onCheckTerms,
    isTermsAccept,
    isTermsAcceptValid,
    onCheckPrivacy,
    isPrivacyAccept,
    isPrivacyAcceptValid,
    isRegistrationLoading,
    responseServerErr,
    registerFormData,
    onBirthdayHandle,
    onComparableTextHandle,
    comparableIsEmpty,
    getValidGenders,
    isBirthdayValid,
    isValidGenders,
    isValidEmail,
    handleChange,
    handleBlur,
    isValidPassword,
    isConsistency,
    comparableText,
    isValidTextInput,
    handleComparableTextHandle,
  } = useController();
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="register-page">
      <FirstTimeInGameModal />
      <GenderNotification />
      <BaseFormPage
        onNavigate={() => {
          // item 26: «Назад» всегда ведёт куда-то. Знаем откуда пришли
          // (state.from: /end-game после WantToKnow «Да», свайпер) — туда;
          // иначе (инвайт-флоу без state, где navigate(-1) был no-op) — на лендинг.
          return navigate(location.state?.from || ROUTES.LANDING_PAGE);
        }}
        renderActionFormButton={() => (
          <NavigateToLoginBtn
            params={
              location.state &&
              location.state.buttonType &&
              location.state.buttonType === "buyGame"
                ? location.state
                : null
            }
          />
        )}
        // item 29: переключатель языка на странице регистрации (в т.ч. «Тебя
        // пригласили к тесту!»), чтобы можно было сменить язык до входа.
        renderLangSwitch={() => <MobileAppSelectLang />}
      >
        <FormHeader title={t("register_page.register_title")} />
        <form
          onSubmit={onSubmitForm}
          className="register-page__register-form"
          action=""
        >
          <BaseInput
            id="register-name"
            disabledBlur
            inputMode="text"
            onChange={handleChange}
            name="firstName"
            value={registerFormData.firstName}
            autocomplete="off"
            maxlength={20}
            type="text"
            label={t("name_label")}
            errorMessage={
              !isValidTextInput ? t("register_page.firstname_validate") : ""
            }
          />
          <div className="register-page__person-info">
            <RadioGenders
              isGendersValid={isValidGenders}
              type="register"
              formData={registerFormData}
              gender={registerFormData.gender}
              onChange={handleChange}
              getValidGenders={getValidGenders}
            />
          </div>
          <BirthDayDatePicker
            isBirthdayValid={isBirthdayValid}
            birthDay={registerFormData.birthday}
            onBirthdayHandle={onBirthdayHandle}
          />
          <BaseInput
            name="email"
            disabledBlur
            inputMode="email"
            value={registerFormData.email}
            id="register-email"
            onChange={handleChange}
            onBlur={handleBlur}
            type="email"
            label={t("email_label")}
            autocomplete="off"
            errorMessage={
              !isValidEmail ? t("register_page.email_validate") : ""
            }
          />
          <BaseInput
            id="register-pass"
            disabledBlur
            onChange={handleChange}
            value={registerFormData.password}
            name="password"
            type="password"
            onBlur={handleBlur}
            label={t("password_label")}
            errorMessage={
              !isValidPassword ? t("register_page.validate_pass") : ""
            }
          />
          <BaseInput
            id="register-repeat-pass"
            disabledBlur
            onChange={handleComparableTextHandle}
            name="repeat_pass"
            value={comparableText}
            type="password"
            onBlur={handleBlur}
            label={t("repeat_password_label")}
            errorMessage={
              !isConsistency
                ? t("register_page.same_pass")
                : comparableIsEmpty
                ? t("register_page.fill_in_pass_repeatly")
                : ""
            }
          />
          <div className="register-page__error">
            <BaseError errorMessage={responseServerErr} />
          </div>
          <TermsAndPrivacy
            isTermsAcceptValid={isTermsAcceptValid}
            checkedTerms={isTermsAccept}
            onCheckTerms={onCheckTerms}
            isPrivacyAcceptValid={isPrivacyAcceptValid}
            checkedPrivacy={isPrivacyAccept}
            onCheckPrivacy={onCheckPrivacy}
          />
          <BaseButton
            type="submit"
            loading={isRegistrationLoading}
            className="register-page__next-register"
          >
            {t("next")}
          </BaseButton>
        </form>
        <div className="register-page-support-btn">
          <SupportButton />
        </div>
      </BaseFormPage>
    </div>
  );
}, ROUTES.PERSONAL_ACCOUNT_PAGE);
